import { INSURANCE_PROVIDER_LOOKUP_TYPE } from './insurance-provider-lookup-type'

const SELF_PAY_LIKE_TYPES: ReadonlySet<INSURANCE_PROVIDER_LOOKUP_TYPE> = new Set([
  INSURANCE_PROVIDER_LOOKUP_TYPE.AUTO_INSURANCE,
  INSURANCE_PROVIDER_LOOKUP_TYPE.LIEN,
  INSURANCE_PROVIDER_LOOKUP_TYPE.SELF_PAY,
  INSURANCE_PROVIDER_LOOKUP_TYPE.WORKERS_COMP_INSURANCE,
  INSURANCE_PROVIDER_LOOKUP_TYPE.INMATE,
])

export function isLikeSelfPayInsuranceType(type: INSURANCE_PROVIDER_LOOKUP_TYPE | undefined): boolean {
  return type !== undefined && SELF_PAY_LIKE_TYPES.has(type)
}
